/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyJobCategory } from '../models/CompanyJobCategory';
import type { CompanyJobCategorySort } from '../models/CompanyJobCategorySort';
import type { CreateCompanyCategoryRequest } from '../models/CreateCompanyCategoryRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CompanyCategoryService {

    /**
     * Get company categories
     * @returns CompanyJobCategory Success
     * @throws ApiError
     */
    public static getCompanyCategories({
        sort,
        limit,
        search,
        offset,
        ignorePagination,
    }: {
        /**
         * Sorting options
         */
        sort?: CompanyJobCategorySort,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Search
         */
        search?: string,
        /**
         * Pagination Offset
         */
        offset?: number,
        /**
         * Ignore pagination
         */
        ignorePagination?: boolean,
    }): CancelablePromise<Array<CompanyJobCategory>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/category',
            query: {
                'sort': sort,
                'limit': limit,
                'search': search,
                'offset': offset,
                'ignorePagination': ignorePagination,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Create company category
     * @returns CompanyJobCategory Success
     * @throws ApiError
     */
    public static createCompanyCategory({
        requestBody,
    }: {
        requestBody?: CreateCompanyCategoryRequest,
    }): CancelablePromise<CompanyJobCategory> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/category',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * Delete company categories
     * @returns any Success
     * @throws ApiError
     */
    public static deleteCompanyCategories({
        categoryIds,
    }: {
        /**
         * Category Ids To Delete
         */
        categoryIds?: Array<number>,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/category',
            query: {
                'categoryIds': categoryIds,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * Update company category
     * @returns CompanyJobCategory Success
     * @throws ApiError
     */
    public static updateCompanyCategory({
        id,
        requestBody,
    }: {
        /**
         * Company Job Category ID
         */
        id: number,
        requestBody?: {
            categoryTitle?: string;
        },
    }): CancelablePromise<CompanyJobCategory> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/category/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete company category
     * @returns any Success
     * @throws ApiError
     */
    public static deleteCompanyCategory({
        id,
    }: {
        /**
         * Company Job Category ID
         */
        id: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/category/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
